import React, {useRef} from 'react';
import Modal from '@material-ui/core/Modal';
import Typography from "@material-ui/core/Typography";
import {Card, CardContent} from "@material-ui/core";
import {makeStyles} from '@material-ui/core/styles';
import GenericModal from '../GenericModal'
import {Formik, Field} from "formik";
import TextField from '@material-ui/core/TextField';
import clsx from "clsx";
import MenuItem from "@material-ui/core/MenuItem";
import * as Yup from 'yup'
import CreateEditUserForm from "../../Forms/Users/CreateEditUserForm";
import axios from 'axios'
import {STORE_USER} from '../../../api/Api'
import useLocationData from "../../../hooks/DataProvider/useLocationData";


function rand() {
    return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}


const useStyles = makeStyles(theme => ({
    modalContainer: {
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        outline: 'none',
    },
    textFieldContainer: {
        display: 'block',
        width: '100%'
    }
}));


const ValidationSchema = Yup.object().shape(
    {
        nom: Yup.string().required('Vous devez saisir le nom de l\'utilisateur'),
        prenoms: Yup.string().required('Vous devez saisir le prénoms de l\'utilisateur'),
        email: Yup.string().email('Vous devez saisir une adresse email valide').required('Vous devez saisir l\'adresse email de l\'utilisateur')
            .matches(
                /^([-A-Za-z0-9]+)@(gs2e|cie)\.(com|ci)$/,
                "Vous devez utilisé une adresse email 'gs2e' ou 'cie'"
            ),
        phone: Yup.string().matches(
            /^[0-9]{10}$/, 'Vous devez saisir un numéro de téléphone valide'
        ).required('Champ obligatoire'),
    }
);

function extractLocationPath(villes,locations) {

    const depthProperty = [
        {currentLevel: 'ville',childs: 'communes'},
        {currentLevel: 'commune',childs: 'quartiers'},
        {currentLevel: 'quartier',childs: 'rues'},
        {currentLevel: 'rue'}
    ];

    function matchLocation(map){
        return locations.filter(
            location => {

                let isMatch = location.location_type == map.level &&
                    location.location_id == map.level_id;

                console.log('matchLocation',map.ville.id,location.location_type,location.location_id,map.level_id,isMatch)

                return isMatch;
            }
        ).map(
            location => {

                return {
                    ville: map.ville?.id,
                    commune: map.commune?.id,
                    quartier: map.quartier?.id,
                    rue: map.rue?.id,
                }

            }
        )
    }

    function explore(depth,list,map){

        const matched = [];

        for(let i=0;i<list.length;i++){

            let item = list[i];
            let depthPropertyElement = depthProperty[depth];
            let subItems = item[depthPropertyElement.childs];

            map[depthPropertyElement.currentLevel] = item;

            map.level = depthPropertyElement.currentLevel;
            map.level_id = item.id;

            const levelMatch = matchLocation(map);
            let childMatch = [];

            if(
                !!subItems && Array.isArray(subItems)
                && subItems.length > 0
            )
                childMatch = [
                    ...explore(depth+1,subItems, {...map})
                ];


             matched.push(...levelMatch)
             matched.push(...childMatch)
        }

        return matched
    }

    return explore(0,villes,{})
}

function extractLocationPathOld(villes,locations){

    for(let villeI = 0;villeI<villes.length;villeI++){

        let ville = villes[villeI]
        let communes = ville.communes;

        for(let communeI = 0;communeI<communes.length;communeI++){

            let commune = communes[communeI]
            let quartiers = commune.quartiers;

            for(let quartierI = 0;quartierI<communes.length;quartierI++){

                let quartier = communes[quartierI]
                let rues = quartier.quartiers;

                for(let rueI = 0;rueI<communes.length;rueI++){

                    let rue = quartier[rueI]


                }



            }


        }

    }

}

export default function CreateUserModal(props) {

    const {onUserUpdated, onCancel, user, ...otherProps} = props;

    const formRef = useRef(null);

    const [isCreatingUser, setIsCreatingUser] = React.useState(false);

    const [isLoadingVilles,villes] = useLocationData('villes')

    const locations = React.useMemo(()=>{

        if(villes && villes.length > 0)
            return extractLocationPath(villes,user.locations)

        return [];
    },[villes]);

    console.log('locations',locations,villes)

    function submitForm() {

        if (formRef.current)
            formRef.current.submitForm();

    }

    function hydrateFormWithError(errors) {

        console.log(formRef)
        console.log(errors)

        if (errors.data.violations)
            errors.data.violations.forEach(
                item => {
                    formRef.current.setFieldError(item.propertyPath, item.message)
                }
            )

        else {
            //TODO: display some error alert
            console.log('Une erreur est survenue')
        }

    }

    async function onFormSubmitted(value) {

        setIsCreatingUser(true)

        try {


            const locations = value.locations.map(
                item => {

                    if(item.rue)
                        return {location_type: 'rue',location_id: item.rue}

                    if(item.quartier)
                        return {location_type: 'quartier',location_id: item.quartier}

                    if(item.commune)
                        return {location_type: 'commune',location_id: item.commune}

                    if(item.ville)
                        return {location_type: 'ville',location_id: item.ville}

                }
            );

            const response = await axios.patch(`${STORE_USER}/${user.id}`, {
                    email: value.email,
                    societe: value.societe,
                    matricule: value.matricule,
                    locations,
                    nom: value.nom,
                    prenoms: value.prenoms,
                    phone: value.phone,
                    role: value.role,
                    password: value.password

                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

            onUserUpdated(response.data);

        } catch (e) {

            if (e.response) {

                switch (e.response.status) {
                    case 400:
                        hydrateFormWithError(e.response)
                        break;
                }

            }

        } finally {
            setIsCreatingUser(false);
        }

    }

    return (
        <GenericModal
            {...otherProps}
            title={'Modifiez un utilisateur'}
            negativeText={'Annnuler'}
            positiveText={'Modifiez l\'utilisateur'}
            onPositive={submitForm}
            onNegative={onCancel}
            isSubmittingData={isCreatingUser}
        >

            <CreateEditUserForm
                initialValues={
                    {
                        ...user,
                        password: '',
                        locations,
                        role: user.roles[0].id
                    }
                }
                ValidationSchema={ValidationSchema}
                onSubmitForm={onFormSubmitted} ref={formRef}/>

        </GenericModal>
    );

}